import { createStyles, makeStyles } from "@material-ui/styles";
import deepmerge from "deepmerge";
import * as React from "react";

import { Link, RelodeTheme, Text } from "../";
import { RelodeCSSProperties } from "../styles";
import { FacetListItem, IFacet } from "./";

const baseStyles = (theme: RelodeTheme) =>
    createStyles({
        root: {
            marginBottom: theme.spacing(2),
        },
        title: {
            textTransform: "lowercase",
            color: theme.relode.colors.alternate.main,
            fontWeight: 600,
        },
        hide: {
            display: "none",
        },
        show: {
            display: "block",
        },
        lessMoreText: {
            paddingBottom: 0,
            fontSize: "0.875rem",
        },
    });

type FacetCSSProperties = "root" | "title" | "hide" | "show" | "lessMoreText";
export type FacetStyles = RelodeCSSProperties<FacetCSSProperties>;

const useStyles = makeStyles(
    (theme: RelodeTheme) => deepmerge(baseStyles(theme), {}),
    { name: "facet" }
);

interface Props {
    id?: string;
    onFilter?: () => void;
    facets: IFacet[];
    title: string;
    noOfFacetsDisplayed?: number;
}

export const Facet = (props: Props) => {
    const { id, onFilter, facets, title, noOfFacetsDisplayed = 5 } = props;

    const classes = useStyles({});
    const [expanded, setExpanded] = React.useState(false);

    const toggleExpand = () => {
        setExpanded(old => !old);
    };

    return (
        <div
            className={classes.root}
            id={`${id}-facet`}
            data-cy={`${id}-facet`}
        >
            <Text variant="subtitle2" className={classes.title} gutterBottom>
                {title}
            </Text>

            {onFilter && (
                <div data-cy={`${id}-facets-list`}>
                    {facets.map((facet, index) => (
                        <div
                            data-cy={`${facet.id}-searchFacet`}
                            key={facet.id}
                            className={
                                index < noOfFacetsDisplayed || expanded
                                    ? classes.show
                                    : classes.hide
                            }
                        >
                            <FacetListItem facet={facet} onFilter={onFilter} />
                        </div>
                    ))}
                </div>
            )}

            {facets.length > noOfFacetsDisplayed ? (
                <Link
                    data-cy={`${id}-facets-moreLess`}
                    className={classes.lessMoreText}
                    onClick={toggleExpand}
                    gutterBottom={false}
                >
                    {expanded ? "less" : "more"}
                </Link>
            ) : null}
        </div>
    );
};
